import { isPlayerKioskPath } from "./kiosk-policy";

// Re-exported so consent-aware UI keeps a single import; the definition lives
// with the kiosk analytics policy that depends on it.
export { isPlayerKioskPath };

export const CONSENT_STORAGE_KEY = "om_consent";
export const CONSENT_COOKIE_NAME = "om_consent";

export type ConsentChoice = "all" | "necessary" | null;

export function readConsent(): ConsentChoice {
  if (typeof window === "undefined") return null;
  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (stored === "all" || stored === "necessary") return stored;
  } catch {
    // localStorage may be blocked
  }
  return null;
}

export function writeConsent(choice: Exclude<ConsentChoice, null>): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, choice);
    document.cookie = `${CONSENT_COOKIE_NAME}=${choice}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
  } catch {
    // ignore
  }
}

export function analyticsAllowed(choice: ConsentChoice = readConsent()): boolean {
  return choice === "all";
}
